import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CategoryQuestions from './CategoryQuestions';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Category Questions | Admin',
    component: (
      <AdminLayout>
        <CategoryQuestions />
      </AdminLayout>
    ),
  };
}

export default action;
